<template lang="pug">
  .chart-box
    price-chart.price-chart
</template>

<script>
  import PriceChart from './ChartBox/PriceChart.vue'

  export default {
    components: {
      PriceChart
    }
  }
</script>

<style lang="sass" scoped>
  .chart-box, .price-chart
    height: 15.25rem
</style>
